import template from './contract_type.create.html'
import controller from './contract_type.create.controller'
import './contract_type.create.scss'

const contractTypeCreateComponent = {
    restrict: 'E',
    bindings: {
        acl: '=',
        hasACL: '='
    },
    template,
    controller
}

export default contractTypeCreateComponent;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/contract_type/create/contract_type.create.component.js